import { buildNumberValue } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.utils';

export const FORM_FIELDS_MAP = {
  Status: {
    key: 'status',
    paramKey: 'status_id',
    outboundAccesor: 'id'
  },
  EstimatedFeeAmount: {
    key: 'estimatedFeeAmount',
    paramKey: 'fee_amount',
    outboundAccesor: buildNumberValue
  },
  AccountableRecruiter: {
    key: 'accountableRecruiter',
    paramKey: 'job_order_accountable_id',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter',
    paramKey: 'candidate_accountable_id',
    outboundAccesor: 'id'
  },
  HiringAuthority: {
    key: 'hiringAuthority',
    paramKey: 'hiring_authority_id',
    outboundAccesor: 'id'
  },
  DeclinationDetails: {
    key: 'declinationDetails'
  }
};
